export default {
  percentChartOptions: {
    grid: {
      show: true,
      padding: {
        left: 0,
        right: 0
      },
      borderColor: '#e7e7e7',
    },
    chart: {
      toolbar: { show: true },
      dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 4,
      opacity: 0.10,
      },
  },
    stroke: {
      curve: 'smooth',
      dashArray: [0, 10],
      width: [4, 2],
  },
  grid: {
    borderColor: '#e7e7e7',
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: true,
  },
  colors: ['#9ecc38', '#F97794'],
  fill: {
    type: 'gradient',
    gradient: {
        shade: 'dark',
        inverseColors: false,
        gradientToColors: ['#3ec9d6', '#7367F0'],
        shadeIntensity: 1,
        type: 'horizontal',
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100]
    },
  },
    markers: {
      size: 5,
      hover: {
        size: 5
      }
    },
    xaxis: {
      labels: {
          style: {
              cssClass: 'text-grey fill-current',
          }
      },
      axisTicks: {
          show: false,
      },
      axisBorder: {
          show: false,
      },
  },
  yaxis: {
      tickAmount: 5,
      labels: {
          style: {
               cssClass: 'text-grey fill-current',
          },
          formatter: function(val) {
              return val.toLocaleString()+" %";
          }
      },
  },
    tooltip: {
      x: { show: true }
    },
  },
  networkChartOptions: {
    grid: {
      show: true,
      padding: {
        left: 0,
        right: 0
      },
      borderColor: '#e7e7e7',
    },
    chart: {
      toolbar: { show: true },
      dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 4,
      opacity: 0.10,
      },
  },
    stroke: {
      curve: 'smooth',
      dashArray: [0, 10],
      width: [4, 2],
  },
  grid: {
    borderColor: '#e7e7e7',
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: true,
  },
  colors: ['#9ecc38', '#F97794'],
  fill: {
    type: 'gradient',
    gradient: {
        shade: 'dark',
        inverseColors: false,
        gradientToColors: ['#3ec9d6', '#7367F0'],
        shadeIntensity: 1,
        type: 'horizontal',
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100]
    },
  },
    markers: {
      size: 5,
      hover: {
        size: 5
      }
    },
    xaxis: {
      labels: {
          style: {
              cssClass: 'text-grey fill-current',
          }
      },
      axisTicks: {
          show: false,
      },
      axisBorder: {
          show: false,
      },
  },
  yaxis: {
      tickAmount: 5,
      labels: {
          style: {
               cssClass: 'text-grey fill-current',
          },
          formatter: function(val) {
              return val.toLocaleString()+" MB";
          }
      },
  },
    tooltip: {
      x: { show: true }
    },
  },
  numberChartOptions: {
    grid: {
      show: true,
      padding: {
        left: 0,
        right: 0
      },
      borderColor: '#e7e7e7',
    },
    chart: {
      toolbar: { show: true },
      dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 4,
      opacity: 0.10,
      },
  },
    stroke: {
      curve: 'smooth',
      dashArray: [0, 10],
      width: [4, 2],
  },
  grid: {
    borderColor: '#e7e7e7',
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: true,
  },
  colors: ['#9ecc38', '#F97794'],
  fill: {
    type: 'gradient',
    gradient: {
        shade: 'dark',
        inverseColors: false,
        gradientToColors: ['#3ec9d6', '#7367F0'],
        shadeIntensity: 1,
        type: 'horizontal',
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100]
    },
  },
    markers: {
      size: 5,
      hover: {
        size: 5
      }
    },
    xaxis: {
      labels: {
          style: {
              cssClass: 'text-grey fill-current',
          }
      },
      axisTicks: {
          show: false,
      },
      axisBorder: {
          show: false,
      },
  },
  yaxis: {
      tickAmount: 5,
      labels: {
          style: {
               cssClass: 'text-grey fill-current',
          },
          formatter: function(val) {
              return val.toLocaleString();
          }
      },
  },
    tooltip: {
      x: { show: true }
    },
  }

}
